module.exports = __webpack_public_path__ + "img/page-34.a249872f.jpg";